import fetchService from '@/services/fetchService';
import axios from 'axios';

export const state = {
  loading: true,
  data: {},
  updateKey: 1,
  snackbar: false,
  snackbarText: '',
};

export const actions = {
  HANDLE_SNACKBAR({ commit }, { snackbar, snackbarText }) {
    console.log(snackbar);
    console.log(snackbarText);
    console.log('HANDLE_SNACKBAR');
    commit('MUTATE_SNACKBAR', { snackbar, snackbarText });
  },

  HANDLE_VIDEO_CHANGE(
    { commit, dispatch },
    { video, candidateId, candidateFirstName, candidateSurname }
  ) {
    console.log(commit);
    console.log(candidateId);
    console.log(video);

    // let self = this;

    // this.vimeoId = null;

    let vimeoId = null;

    let Vimeo = require('vimeo').Vimeo;
    let client = new Vimeo(
      '757d27075fbb47670d8e45a767f6c2ce7b050279',
      'FAmshigr/NFiWUjSw1Hi/etD4b7Lflh318tHkR7RiTGT3rVhna7V5vkU60I/nXO+CK5fhDzdYTb/7BTyKh7VERJ6NmQX7VHfMsl1Y3DzgT2oFa5eAiEEjPHXq2L/goS4',
      '9ea71d9d177393d7954e1a5a725b070c'
    );

    client.upload(
      video,
      {
        name: candidateFirstName + candidateSurname,
        description: 'Candidate Job Application Video',
        privacy: { view: 'unlisted' },
      },
      function (uri) {
        console.log('Your video URI is: ' + uri);

        vimeoId = uri.replace(/\D/g, '');

        //self.putCandidateData();
        //self.getVimeoThumb(client, uri.replace(/\D/g, ''));

        console.log('PUTTING');
        axios
          .put(
            process.env.VUE_APP_REST_HTTP
              ? `${process.env.VUE_APP_REST_HTTP}/candidates/${candidateId}`
              : `http://localhost:1337/candidates/${candidateId}`,
            {
              video: vimeoId,
              //videoThumb: self.vimeoThumb,
            }
          )
          .then(function () {
            dispatch('UPDATE_VIDEO', vimeoId);
            console.log('done');
            dispatch('HANDLE_SNACKBAR', {
              snackbar: true,
              snackbarText: 'Your video has been updated.',
            });
            commit('UPDATE_CANDIDATE');
            //alert('You have successfully updated your video');
            // self.handleAppliedSuccess();
            //self.$store.dispatch('UPDATE_VIDEO', self.vimeoId);
          });
      },
      function (bytes_uploaded, bytes_total) {
        var percentage = ((bytes_uploaded / bytes_total) * 100).toFixed(2);
        console.log(bytes_uploaded, bytes_total, percentage + '%');
      },
      function (error) {
        console.log('Failed because: ' + error);
      }
    );
  },

  async FETCH_DATA({ commit }, id) {
    console.log('FETCH');
    try {
      const response = await fetchService.fetchData(`/candidates/${id}`);

      // localStorage.setItem('exercises', response.data);
      commit('SET_DATA', response.data);
    } catch (error) {
      console.log(error);
    }
  },
  HANDLE_RESUME_CHANGE({ commit, dispatch }, payload) {
    console.log('HANDLE');
    console.log(payload);
    console.log(commit);

    // upload resume
    let formData = new FormData();
    formData.append('files', payload.resume);
    console.log('>> formData >> ', formData);

    axios
      .post(
        process.env.VUE_APP_REST_HTTP
          ? `${process.env.VUE_APP_REST_HTTP}/upload`
          : 'http://localhost:1337/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then(function () {
        console.log('getLastResume');
        axios
          .get(
            process.env.VUE_APP_REST_HTTP
              ? `${process.env.VUE_APP_REST_HTTP}/upload/files?_sort=created_at:DESC`
              : 'http://localhost:1337/upload/files?_sort=created_at:DESC'
          )

          .then(function (response) {
            axios
              .put(
                process.env.VUE_APP_REST_HTTP
                  ? `${process.env.VUE_APP_REST_HTTP}/applicants/${payload.resumeId}`
                  : `http://localhost:1337/applicants/${payload.resumeId}`,
                {
                  resume: response.data[0].id,
                }
              )
              .then(function () {
                dispatch('HANDLE_SNACKBAR', {
                  snackbar: true,
                  snackbarText: 'Resume updated',
                });
                commit('UPDATE_CANDIDATE');
              });
          });
      });
  },
};

export const mutations = {
  SET_DATA(state, data) {
    console.log(data);
    state.data = data;
    state.loading = false;
  },
  UPDATE_CANDIDATE(state) {
    console.log(state);
    state.updateKey = state.updateKey + 1;
  },
  MUTATE_SNACKBAR(state, { snackbar, snackbarText }) {
    state.snackbar = snackbar;
    state.snackbarText = snackbarText;
  },
};

export const getters = {
  getCandidate(state) {
    console.log(state);
    return state.data;
  },
  getResumeHash(state) {
    return state.candidate.data.resume.hash;
  },
};
